import { usePageMeta } from '@/hooks/usePageMeta'

function PolitiqueConfidentialite() {
  usePageMeta({
    title: 'Politique de confidentialité',
  })

  return (
    <div className="container" style={{ padding: '2rem 0' }}>
      <h1>Politique de confidentialité</h1>

      <section style={{ marginTop: '2rem' }}>
        <p>
          La présente politique de confidentialité décrit la manière dont l'association "Avenir Théopolitain 2026" collecte, utilise et protège vos données personnelles lorsque vous utilisez le site <strong>avenirtheropolitain.fr</strong>.
        </p>
        <p>
          Nous nous engageons à respecter la confidentialité de vos données personnelles conformément au Règlement Général sur la Protection des Données (RGPD - Règlement UE 2016/679) et à la loi "Informatique et Libertés" du 6 janvier 1978 modifiée.
        </p>
      </section>

      <section style={{ marginTop: '2rem' }}>
        <h2>1. Responsable du traitement</h2>
        <p>
          Le responsable du traitement des données personnelles est l'association "Avenir Théopolitain 2026".
        </p>
        <p>
          <strong>Contact :</strong> contact@avenirtheropolitain.fr
        </p>
      </section>

      <section style={{ marginTop: '2rem' }}>
        <h2>2. Données collectées</h2>
        <p>
          Nous collectons uniquement les données personnelles que vous nous fournissez volontairement via le formulaire de contact du site.
        </p>

        <h3 style={{ marginTop: '1rem' }}>2.1. Formulaire de contact</h3>
        <p>
          Lorsque vous utilisez le formulaire de contact, nous collectons :
        </p>
        <ul>
          <li>Votre nom et prénom</li>
          <li>Votre adresse email</li>
          <li>Votre message</li>
          <li>Votre consentement RGPD (case à cocher obligatoire)</li>
          <li>La date et l'heure de l'envoi du message</li>
        </ul>

        <h3 style={{ marginTop: '1rem' }}>2.2. Données de navigation</h3>
        <p>
          Nous ne collectons <strong>aucune donnée de navigation</strong>. Le site n'utilise pas d'outil d'analyse d'audience (Google Analytics ou autre) et ne dépose aucun cookie de suivi.
        </p>
      </section>

      <section style={{ marginTop: '2rem' }}>
        <h2>3. Finalités du traitement</h2>
        <p>
          Les données collectées via le formulaire de contact sont utilisées uniquement pour :
        </p>
        <ul>
          <li>Répondre à vos demandes d'information</li>
          <li>Traiter vos questions ou remarques concernant la campagne</li>
          <li>Vous contacter dans le cadre de votre demande</li>
        </ul>
        <p>
          Vos données ne sont jamais utilisées à des fins commerciales, publicitaires ou de prospection, et ne sont jamais cédées, vendues ou louées à des tiers.
        </p>
      </section>

      <section style={{ marginTop: '2rem' }}>
        <h2>4. Base légale du traitement</h2>
        <p>
          Le traitement de vos données personnelles repose sur votre <strong>consentement explicite</strong>, matérialisé par la case à cocher obligatoire du formulaire de contact, conformément à l'article 6.1.a du RGPD.
        </p>
      </section>

      <section style={{ marginTop: '2rem' }}>
        <h2>5. Destinataires des données</h2>
        <p>
          Vos données personnelles sont accessibles uniquement par :
        </p>
        <ul>
          <li>Les administrateurs de la campagne "Avenir Théopolitain 2026" habilités à traiter les demandes de contact</li>
          <li>L'hébergeur du site, O2Switch (France), dans le cadre de ses obligations d'hébergement et de maintenance technique</li>
        </ul>
        <p>
          Aucun tiers n'a accès à vos données personnelles. Nous ne partageons, ne vendons ni ne louons vos informations à des partenaires commerciaux ou publicitaires.
        </p>
      </section>

      <section style={{ marginTop: '2rem' }}>
        <h2>6. Durée de conservation</h2>
        <p>
          Les données collectées via le formulaire de contact sont conservées pendant une durée maximale de <strong>12 mois</strong> à compter de leur collecte, sauf si vous demandez leur suppression avant ce délai.
        </p>
        <p>
          Passé ce délai, vos données sont automatiquement supprimées de notre base de données.
        </p>
      </section>

      <section style={{ marginTop: '2rem' }}>
        <h2>7. Sécurité des données</h2>
        <p>
          Nous mettons en œuvre toutes les mesures techniques et organisationnelles appropriées pour protéger vos données personnelles contre la perte, l'utilisation abusive, l'accès non autorisé, la divulgation, l'altération ou la destruction.
        </p>
        <p>
          Ces mesures incluent notamment :
        </p>
        <ul>
          <li>Hébergement sécurisé en France (O2Switch)</li>
          <li>Connexion HTTPS chiffrée (SSL/TLS)</li>
          <li>Mots de passe chiffrés pour l'accès administrateur</li>
          <li>Sauvegardes régulières</li>
          <li>Accès restreint aux données (authentification requise)</li>
        </ul>
      </section>

      <section style={{ marginTop: '2rem' }}>
        <h2>8. Vos droits</h2>
        <p>
          Conformément au RGPD et à la loi "Informatique et Libertés", vous disposez des droits suivants concernant vos données personnelles :
        </p>
        <ul>
          <li><strong>Droit d'accès :</strong> Vous pouvez obtenir la confirmation que vos données sont traitées et accéder à ces données</li>
          <li><strong>Droit de rectification :</strong> Vous pouvez demander la correction de données inexactes ou incomplètes</li>
          <li><strong>Droit à l'effacement ("droit à l'oubli") :</strong> Vous pouvez demander la suppression de vos données</li>
          <li><strong>Droit à la limitation du traitement :</strong> Vous pouvez demander la suspension du traitement de vos données</li>
          <li><strong>Droit d'opposition :</strong> Vous pouvez vous opposer au traitement de vos données</li>
          <li><strong>Droit à la portabilité :</strong> Vous pouvez recevoir vos données dans un format structuré et lisible</li>
          <li><strong>Droit de retirer votre consentement :</strong> Vous pouvez retirer votre consentement à tout moment</li>
        </ul>

        <h3 style={{ marginTop: '1rem' }}>Comment exercer vos droits ?</h3>
        <p>
          Pour exercer vos droits, vous pouvez nous contacter à l'adresse suivante :
        </p>
        <p>
          <strong>Email :</strong> contact@avenirtheropolitain.fr<br />
          <strong>Objet :</strong> "Exercice de mes droits RGPD"
        </p>
        <p>
          Nous nous engageons à répondre à votre demande dans un délai maximum de <strong>1 mois</strong> à compter de sa réception.
        </p>

        <h3 style={{ marginTop: '1rem' }}>Réclamation auprès de la CNIL</h3>
        <p>
          Si vous estimez que vos droits ne sont pas respectés, vous avez la possibilité d'introduire une réclamation auprès de la Commission Nationale de l'Informatique et des Libertés (CNIL) :
        </p>
        <p>
          <strong>CNIL</strong><br />
          3 Place de Fontenoy - TSA 80715<br />
          75334 Paris Cedex 07<br />
          Téléphone : 01 53 73 22 22<br />
          Site web : <a href="https://www.cnil.fr" target="_blank" rel="noopener noreferrer">www.cnil.fr</a>
        </p>
      </section>

      <section style={{ marginTop: '2rem' }}>
        <h2>9. Cookies</h2>
        <p>
          Le site <strong>avenirtheropolitain.fr</strong> n'utilise <strong>aucun cookie de suivi, d'analyse ou publicitaire</strong>.
        </p>
        <p>
          Seuls des cookies de session strictement nécessaires sont utilisés pour le fonctionnement du back-office administratif (espace de gestion réservé aux administrateurs). Ces cookies sont automatiquement supprimés à la fermeture de votre navigateur et ne collectent aucune donnée personnelle.
        </p>
        <p>
          Aucun cookie n'est déposé lors de votre navigation sur le site public.
        </p>
      </section>

      <section style={{ marginTop: '2rem' }}>
        <h2>10. Transferts de données hors UE</h2>
        <p>
          Toutes vos données personnelles sont hébergées et stockées en <strong>France</strong> (O2Switch, Clermont-Ferrand).
        </p>
        <p>
          Aucun transfert de données en dehors de l'Union Européenne n'est effectué.
        </p>
      </section>

      <section style={{ marginTop: '2rem' }}>
        <h2>11. Modifications de la politique de confidentialité</h2>
        <p>
          Nous nous réservons le droit de modifier la présente politique de confidentialité à tout moment. En cas de modification substantielle, nous vous en informerons par une mention visible sur le site.
        </p>
        <p>
          Nous vous invitons à consulter régulièrement cette page pour prendre connaissance des éventuelles modifications.
        </p>
      </section>

      <section style={{ marginTop: '2rem', marginBottom: '2rem' }}>
        <h2>12. Contact</h2>
        <p>
          Pour toute question concernant cette politique de confidentialité ou le traitement de vos données personnelles, vous pouvez nous contacter à l'adresse :
        </p>
        <p>
          <strong>Email :</strong> contact@avenirtheropolitain.fr
        </p>
        <p>
          <em>Dernière mise à jour : {new Date().toLocaleDateString('fr-FR', { year: 'numeric', month: 'long', day: 'numeric' })}</em>
        </p>
      </section>
    </div>
  )
}

export default PolitiqueConfidentialite
